import React from "react"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import styles from "../../styles/FilterHeader.module.css"

const FilterHeader = ({
  filters,
  globalFilterValue,
  onGlobalFilterChange,
  clearAllFilters,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(true)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={styles["filter-container"]}>
      <div className={styles["filter-header"]}>
        <h3>Filter Options</h3>
        <Button
          icon={isExpanded ? "pi pi-chevron-up" : "pi pi-chevron-down"}
          onClick={toggleExpand}
          className={styles["expand-button"]}
        />
      </div>
      {isExpanded && (
        <>
          <div className={styles["filter-fields"]}>
            <span className="p-input-icon-left" style={{ marginRight: "20px" }}>
              <i className="pi pi-search" />
              <InputText
                value={globalFilterValue}
                onChange={onGlobalFilterChange}
                placeholder="Keyword Search"
              />
            </span>
            {filters.map((filter, index) => (
              <div key={index} className={styles["filter-field"]}>
                <label style={{ marginRight: "5px" }}>{filter.label}:</label>
                {filter.component || (
                  <Dropdown
                    value={filter.value}
                    options={filter.options}
                    onChange={filter.onChange}
                    placeholder={filter.placeholder}
                    filter={filter.enableFilter}
                  />
                )}
              </div>
            ))}
          </div>
          <div className={styles["filter-actions"]}>
            <Button
              label="Reset Filters"
              icon="pi pi-refresh"
              onClick={clearAllFilters}
              className={styles["clear-button"]}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default FilterHeader
